import React, { FC } from 'react';
import styled from 'styled-components';
import { Question } from 'types/quiz';
import { mobile, tablet } from 'styles/breakpoints';
import Text from 'components/Text';
import ContinueButton from './QuizContinueButton';
import { DynamicImage } from 'components';

interface TestimonialProps {
  question: Question;
  onContinue: () => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;

  @media ${tablet} {
    padding-bottom: 10rem;
  }
`;

const Title = styled(Text)`
  margin-bottom: 1.5rem;

  @media ${mobile} {
    text-align: center;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 71.25rem;
  margin-top: 3rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 6rem;

  @media ${mobile} {
    grid-template-columns: 1fr;
    margin-top: 1rem;
  }
`;

const Pragraphs = styled.div`
  p:nth-child(1n):not(:last-child) {
    margin-bottom: 1rem;
  }
  display: initial;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${mobile} {
    margin-top: 1.5rem;
    h2 {
      font-size: 1.2rem;
    }
  }

  strong,
  bold {
    font-family: inherit;
    font-size: inherit;
  }
`;

const Description = styled(Text)`
  font-style: italic;
`;

const Testimonial: FC<TestimonialProps> = ({
  question,
  onContinue,
  ...props
}) => (
  <Container {...props}>
    <Content>
      {question?.image && (
        <DynamicImage src={question.image} alt={question.alt} />
      )}
      <Pragraphs>
        <Title type={'h2'} color="dark100">
          {question.label}
        </Title>
        {question?.paragraphs?.map(p => (
          <Description
            key={p}
            type="body"
            color="dark80"
            dangerouslySetInnerHTML={{ __html: p }}
          />
        ))}
      </Pragraphs>
    </Content>
    <ContinueButton title={question?.nextBtnTitle} onClick={onContinue} />
  </Container>
);

export default Testimonial;
